import { AfterViewInit, ContentChild, Directive, ElementRef, Input, OnChanges, OnDestroy, Renderer2, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { Section } from '../../editor-container/editor-model';
import { ContentElement, GridCell, RowCell } from '@urbannex/storethemes';
import { Subject, Subscription } from 'rxjs';
import { CellEditorStoreService } from '../cell-editor-store.service';
import { map, takeUntil } from 'rxjs/operators';
import { ElementSelectorService } from './element-selector.service';
import { SectionEditorStoreService } from '../dialogs/section-editor-dialog/section-editor-store.service';

@Directive({
  selector: '[kveRenderCell]'
})
export class RenderCellDirective implements OnChanges, AfterViewInit, OnDestroy {
  @Input() section: Section;
  @Input() selectedCell: GridCell | RowCell;
  @Input() rendererComponent: any;
  @Input() title: string;
  @Input() marginBottom: number;
  @Input() activeSelector: ContentElement;
  @Input() selectedTabTitle: string;
  @Input() cellId: string;
  firstShow: boolean = true;

  // @ContentChild(TemplateRef) previewHost:TemplateRef<any>;

  containerTop: number;
  editCellTop: number;
  containerWidth: number;
  containerCenter: number;
  editCellWidth: number;
  editCellLeft: number;

  trackUpdates$: Subscription;
  fillClass$: Subscription;
  fillColor$: Subscription;

  previewElements: HTMLElement[] = [];

  renderedEl: HTMLElement;
  cellEls: NodeListOf<Element>;

  previewSelectors: any[] = [];

  private destroy$ = new Subject<void>()

  readonly activeSelector$ = this.cellEditorStoreService.activeSelector$.pipe(
    takeUntil(this.destroy$),
    map(activeSelector => activeSelector)
  )



  constructor(public viewContainerRef: ViewContainerRef,
    private renderer: Renderer2,
    private el: ElementRef,
    private cellEditorStoreService: CellEditorStoreService,
    private sectionEditorStoreService: SectionEditorStoreService,
    private elSelectorService: ElementSelectorService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["section"]) {
      console.log("Section Changed", this.section);
      console.log(this.section.sectionData.selectedCell)
    }
    /* this.trackUpdates$ = this.cellEditorStoreService.selectedCell$.pipe(takeUntil(this.destroy$)).subscribe(_selectedCell => {
      console.log(_selectedCell);
      if (this.containerTop != undefined) {
        console.log("You can do things now")
      }
    }) */
    this.fillClass$ = this.cellEditorStoreService.fillClass$.subscribe((_fillClass: string) => {
      // console.log("loading fill class")
      // this.refreshPreview();
      /* if(_fillClass != undefined && this.renderedEl != undefined){
        setTimeout(() => {
          console.log("Setting Fill Class")
          let hostEl:HTMLElement = <HTMLElement>this.el.nativeElement;
          this.renderedEl = hostEl.parentElement;
          this.cellEls = this.renderedEl.querySelectorAll('.grid-cell-container');
          this.positionCell(this.cellEls,true);
        },200)

      } */
    })
    this.fillColor$ = this.cellEditorStoreService.fillColor$.subscribe((_fillColor: string) => {
      if (_fillColor != undefined && this.renderedEl != undefined) {
        setTimeout(() => {
          const hostEl: HTMLElement = <HTMLElement>this.el.nativeElement;
          this.renderedEl = hostEl.parentElement;
          this.cellEls = this.renderedEl.querySelectorAll('.grid-cell-container');
          console.log("Calling positionCell from fillColor change")
          // this.positionCell(this.cellEls, true);
        }, 200)

      }
    })
    if (changes["selectedCell"]) {
      console.log("SelectedCell Changed", this.selectedCell);
      this.sectionEditorStoreService.sectionData$.subscribe(sectionData => { console.log(sectionData) })
      setTimeout(() => {
        if (this.cellEls != undefined && this.cellEls.length > 0) {
          console.log("Calling positionCell from selectedCell change")
          this.positionCell(this.cellEls, true);
        }
      }, 500)

    }
    if (changes["activeSelector"]) {

      /* console.log(this.activeSelector);
      let els = this.renderedEl.querySelectorAll(".content-element");
      if(els.length > 0){
        els.forEach(cntEl => {
          if(cntEl.getAttribute("content-element-id") == this.activeSelector.elId){
            console.log(cntEl);
          }
        })

      } */
      /* if(this.activeSelector != undefined){
       console.log(this.activeSelector);
       this.setPreviewSelection(this.activeSelector)
      } */

    }
    /* if(changes["rendererComponent"]){
      console.log("Rendered Component")
      console.log(this.rendererComponent);
    } */
    /* if(changes["selectedTabTitle"]){
      console.log(this.selectedTabTitle)
      if(this.selectedTabTitle != undefined && this.selectedTabTitle == "Styles"){
        if(this.activeSelector != undefined){
          this.setPreviewSelection(this.activeSelector.elId)
        }
      }
    } */
    if (changes["cellId"]) {
      console.log({ "Cell Id changed": this.cellId, "selectedCell": this.selectedCell });
    }
  }

  ngAfterViewInit(): void {
    console.log("In renderCell", this.section);
    console.log((<HTMLElement>this.viewContainerRef.element.nativeElement).previousSibling);
    console.log(this.selectedCell);
    const hostEl: HTMLElement = <HTMLElement>this.el.nativeElement;
    console.log("previewHost", hostEl)
    this.activeSelector$.subscribe(activeSelector => {
      if (activeSelector != undefined) {
        this.activeSelector = activeSelector;
        console.log(activeSelector)
        console.log("Going to setPreviewSelection from ngAfterViewInit")
        this.setPreviewSelection(activeSelector)
      }
    })

    /**
     * This renderer element is the whole section
     */
    this.renderedEl = hostEl.parentElement;
    /**
     * We want to work with only the selected cell
     * So we resolve the selectedEl cell using the cellId
     * We will use the element selector service to find the selectedCell Element
     */
    console.log(this.renderedEl);

    // let renderedChlrd:HTMLCollection = this.renderedEl.children;

    setTimeout(() => {
      this.cellEls = this.renderedEl.querySelectorAll('.grid-cell-container');
      const selectedCellEl = this.elSelectorService.resolveSelectedCell(this.selectedCell, this.renderedEl);
      console.log(selectedCellEl);
      const rendererContentEls = selectedCellEl.querySelectorAll('KW-CONTENT-ELEMENT-RENDERER');
      console.log(rendererContentEls)
      if (rendererContentEls.length > 0) {
        rendererContentEls.forEach((rendererContentEl, i) => {
          const cntEl = rendererContentEl.querySelector('.content-element');
          console.log(cntEl)
          const elId = cntEl.getAttribute('content-element-id');
          const previewEl = <HTMLElement>rendererContentEl.querySelector('.preview-selected');
          this.previewElements.push(previewEl);
          const previewSelector = { elId: elId, previewEl: previewEl };
          this.previewSelectors.push(previewSelector);
          console.log(previewSelector);
        })
        if (this.activeSelector != undefined) {
          console.log("Going to setPreviewSelection from setTimeout")
          this.setPreviewSelection(this.activeSelector)
        } else {
          if (this.selectedCell != null && this.selectedCell != undefined) {
            const contentElements = this.selectedCell.contentElements;
            if (contentElements != undefined && contentElements.length > 0) {
              console.log("Going to setPreviewSelection from setTimeout")
              this.setPreviewSelection(contentElements[0]);
            }
          }
          // }
          /* this.cellEditorStoreService.selectedCell$.subscribe((selectedCell:GridCell) => {
              console.log(selectedCell);
              if(selectedCell != null && selectedCell != undefined){
                this.selectedCell = selectedCell;
                this.contentElements = this.setContentElements(this.selectedCell);
                if(!this.selectedContent){
                  this.selectedContent = this.contentElements[0];
                }
              }
            }) */
          // console.log("Have to set a activeSelector",this.selectedCell)
        }
      }
      console.log(this.cellEls);

      this.positionCell(this.cellEls, true)



    }, 500);

    // this.renderedEl.firstElementChild

    // Collect the preview elements
    const previewElementNodes = this.renderedEl.querySelectorAll('.preview-selected');
    for (let i = 0; i < previewElementNodes.length; i++) {
      this.previewElements.push(<HTMLElement>previewElementNodes[i])
    }

    console.log(previewElementNodes)

    this.firstShow = false;

  }
  /**
   * Positions the selected cell in the center of the rendered section and sets opacity of non selected cells
   * @param cellEls all cell elements in the rendered section
   * @param setOpcity boolean to set opacity of non selected cells
   */
  positionCell(cellEls: NodeListOf<Element>, setOpcity: boolean) {
    console.log("Position Cell Called");
    if (cellEls.length > 1) {
      // let rendererSection = <HTMLElement>renderedChlrd.item(0);
      // let renderedCell: HTMLElement;
      const rect = this.renderedEl.getBoundingClientRect();
      this.containerWidth = rect.width;
      this.containerCenter = this.containerWidth / 2;
      this.containerTop = rect.top;
      /* console.log("Width: " + rect.width + "px");
      console.log("Height: " + rect.height + "px");

      console.log("Top: " + rect.top + "px");
      console.log("Bottom: " + rect.bottom + "px");

      console.log('////////')

      console.log("Width: " + this.renderedEl.offsetWidth + "px");
      console.log("Height: " +this.renderedEl.offsetHeight + "px"); */
      // Get dimensions for selected cell and set opacity for rest to 0;
      const hiddenCells: HTMLElement[] = [];
      for (let i = 0; i < this.cellEls.length; i++) {
        const cell: HTMLElement = <HTMLElement>cellEls[i];
        // console.log(cell);
        const cellId = cell.getAttribute("cell-id");
        if (cellId == this.selectedCell.cellId) {
          // Remove the cell's opacity style attribute if it exists
          if (cell.style.opacity) {
            cell.style.removeProperty("opacity");
          }
          console.log("Cell to highlight and position", cell)
          const cellRect = cell.getBoundingClientRect();
          this.editCellWidth = cellRect.width;
          console.log("Width: " + rect.width + "px");
          console.log("Height: " + rect.height + "px");
          this.editCellTop = cellRect.top;
          console.log("Top: " + rect.top + "px");
          console.log("Bottom: " + rect.bottom + "px");
          this.editCellLeft = cellRect.left;
          console.log("Left: " + rect.left)
        } else {
          hiddenCells.push(cell);
          /* console.log("Setting Opacity");
          cell.style.opacity = "0";
          cell.style.setProperty("opacity","0"); */
        }
      }
      // Adjust selected cell's position verically or horizontally
      if (this.containerTop != undefined && this.editCellTop != undefined) {
        console.log({ containerTop: this.containerTop, editCellTop: this.editCellTop })
        let transFormY = "";
        let transFormX = "";
        // Do the vertical transform
        if (this.editCellTop > this.containerTop) {
          transFormY = this.containerTop - this.editCellTop + "px";
          console.log(transFormY);
          this.renderedEl.style.marginTop = transFormY;
        }
        // Do the horizontal transform;

        if (this.editCellLeft > this.containerCenter) {
          const firstFact = this.editCellLeft - this.containerCenter;
          const secondFact = this.editCellWidth / 2;
          transFormX = firstFact + secondFact + "px";
          console.log(transFormX)
          // this.renderedEl.style.transform = "translateX(-"+transFormX+")";

        } else if (this.editCellLeft < this.containerCenter) {
          const firstFact = this.containerCenter - this.editCellWidth;
          const secondFact = this.editCellWidth / 2;
          const transformX = firstFact + secondFact;
          console.log(transFormX)
          // this.renderedEl.style.transform = "translateX("+transformX+")";
        }
      }
      if (hiddenCells.length > 0 && setOpcity) {
        console.log("Setting opacity for hidden cells");
        hiddenCells.forEach(cell => {
          console.log("setting opacity")
          if (this.section.sectionData.rendererType == "slider" && this.section.sectionData?.sliderType == "show") {
            cell.remove();
          } else {
            cell.style.opacity = "0.3"
          }

        })
      }

      // let cellEls = this.renderedEl.querySelectorAll('.grid-cell-container');


    }
  }

  transFormLayout() {
    console.log("do we ever get here?")
    console.log(this.cellEls);
    setTimeout(() => {
      for (let i = 0; i < this.cellEls.length; i++) {
        const cell: HTMLElement = <HTMLElement>this.cellEls[i];
        // console.log(cell);
        const cellId = cell.getAttribute("cell-id");
        if (cellId == this.selectedCell.cellId) {
          console.log(cell);
          // renderedCell ==  cell;
          const cellRect = cell.getBoundingClientRect();
          this.editCellWidth = cellRect.width;
          this.editCellTop = cellRect.top;
          this.editCellLeft = cellRect.left;
          /* if(this.section.rendererType != "banner"){
            cell.style.display = "none";
          } */
        } else {
          console.log("Setting opacity");
          cell.style.opacity = "0";
        }
      }
      if (this.containerTop != undefined && this.editCellTop != undefined) {
        let transFormY = "";
        let transFormX = "";
        // Do the vertical transform
        if (this.editCellTop > this.containerTop) {
          transFormY = this.containerTop - this.editCellTop + "px";
          console.log(transFormY);
          // rendererSection.style.setProperty("transform","translateY("+transFormY+")")
          // rendererSection.style.transform = "translateY("+transFormY+"px)";
          // console.log(rendererSection)
          this.renderedEl.style.marginTop = transFormY;
        }
        // Do the horizontal transform;

        if (this.editCellLeft > this.containerCenter) {
          const firstFact = this.editCellLeft - this.containerCenter;
          const secondFact = this.editCellWidth / 2;
          transFormX = firstFact + secondFact + "px";
          console.log(transFormX)
          this.renderedEl.style.transform = "translateX(-" + transFormX + ")";

        } else if (this.editCellLeft < this.containerCenter) {
          const firstFact = this.containerCenter - this.editCellWidth;
          const secondFact = this.editCellWidth / 2;
          const transformX = firstFact + secondFact;
          console.log(transFormX)
          this.renderedEl.style.transform = "translateX(" + transformX + ")";
        }
        // console.log({containerTop:this.containerTop,editCellTop:this.editCellTop})
      }
    }, 0)
  }

  setPreviewSelection(selector: ContentElement) {
    console.log(selector);
    const previewSelector = this.previewSelectors.find(prevSel => prevSel.elId === selector.elId);
    console.log(previewSelector);
    const previewEl = previewSelector.previewEl;
    // console.log()
    // console.log("Setting preview : "+selector)
    if (this.previewElements != undefined && this.previewElements.length > 0) {
      this.previewElements.forEach(el => {
        console.log(el)
        if (el != undefined) {
          if (el.classList.contains("show")) {
            el.classList.toggle("show")
          }
          if (!el.classList.contains("hide")) {
            el.classList.toggle("hide");
          }
          if (el === previewEl) {
            el.classList.toggle("show");
          }
        }
      })
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
